import Msg from "./singleton/message";
import Language from "./singleton/language";
import IConfigPhone from "./interface/field-cfg-phone";
import IConfigNumber from "./interface/field-cfg-number";
import IConfigLinked from "./interface/field-cfg-linked";
import IConfigDatetime from "./interface/field-cfg-datetime";
import Message from "./enum/message";
import FieldType from "./enum/field-type";
import DecimalSeparator from "./enum/decimal-separator";
import DateType from "./enum/date-type";
import CurrencyPosition from "./enum/currency-position";

const DefaultConfig = {

    [FieldType.number]: function(): IConfigNumber {
        return {
            decimalSeparator: DecimalSeparator.Comma,
            currencyPosition: CurrencyPosition.Right,
            currencySymbol: '',
            decimalLength: 2
        };
    },

    [FieldType.datetime]: function(type: DateType = DateType.DateOnly): IConfigDatetime {
        if (type === DateType.DateTime) {
            return {
                type: DateType.DateTime,
                format: 'DD MMMM YYYY HH:mm',
                timezone: null,
                mindate: null,
                maxdate: null
            };
        } else {
            return {
                type: DateType.DateOnly,
                format: 'DD MMMM YYYY',
                timezone: null,
                mindate: null,
                maxdate: null
            };
        }
    },

    [FieldType.phone]: function(): IConfigPhone {
        return {
            country: Language.getLocale()
        };
    },

    [FieldType.linked]: function(): IConfigLinked {
        return {
            filters: [],
            forbidRepetitions: false
        };
    },

    PlanningDurationField: function(): IConfigNumber {
        return {
            decimalSeparator: DecimalSeparator.Comma,
            currencyPosition: CurrencyPosition.Right,
            currencySymbol: Msg.get(Message.mins),
            decimalLength: 0
        };
    }

};

export default DefaultConfig;